module.exports = __webpack_public_path__ + "static/img/hkj1.2cafd66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/hkj1.jpg
// module id = LL78
// module chunks = 0